import React from 'react'
import { useTranslation } from 'react-i18next'
import { StakeButtonProps } from '@plug-core/interfaces/staking'
import { useStakeButton } from '@plug-core/hooks/useStaking'
import Button from '@components/Button'

export const StakeButton = ({ isLoading, ...props }: StakeButtonProps) => {
  const { t } = useTranslation()
  const { userError, reviewStake } = useStakeButton(props)

  return (
    <Button
      variant="rainbow"
      disabled={!!userError || isLoading}
      onClick={reviewStake}
      fullWidth={true}
    >
      {userError || t('stake.stakeIcp')}
    </Button>
  )
}
